import styles from './FilterCheckboxes.module.scss'
import { FilterType, useFilter } from '@/utils/hooks/useFilter'
import React from 'react'
import Checkbox from '@/components/inputs/Checkbox/Checkbox'
import NameValue from '@/types/NameValue'

type Props = {
  property: string,
  items: any[],
  values?: NameValue[],
  selected?: any[],
  onClick: (property: string, value: any, filterType: FilterType) => void,
  label?: string,
}

const FilterCheckboxes = (props: Props) => {
  const { getValuesByPropery } = useFilter(props.items, null)

  const values = props.values ?? getValuesByPropery(props.property).map((value) => ({ name: value, value }))

  const onFilterButtonClick = (checked: boolean, name: string) => {
    props.onClick(props.property, name, FilterType.Checkbox)
  }

  return (
    <div className={styles.component}>
      {props.label && (
        <label className={styles.label}>{props.label}</label>
      )}
      <div className={styles.checkboxes}>
        {
          values.map((item) =>
            <Checkbox
              key={item.value}
              label={item.name}
              name={item.value}
              checked={props.selected?.includes(item.value) ?? false}
              onChange={onFilterButtonClick}
            />
          )
        }
      </div>
    </div>
  )
}

export default FilterCheckboxes